import { ComponentRef, Directive, effect, inject, input, ViewContainerRef } from '@angular/core';
import { Registry } from './registry';

@Directive({
    selector: '[dynamic]',
    standalone: false
})
export class DynamicDirective {
    private readonly vcr = inject(ViewContainerRef);

    private componentRef?: ComponentRef<any>;

    readonly model = input<any>(undefined, { alias: 'dynamic' });

    constructor() {
        effect(() => {
            const model = this.model();

            if (!model) {
                this.vcr.clear();
                this.componentRef = undefined;
                return;
            }

            this.render(model);
        });
    }

    private render(model: any): void {
        const component = Registry.get(model.component);

        this.vcr.clear();
        this.componentRef = this.vcr.createComponent(component);

        this.componentRef?.setInput('model', model);
    }
}
